// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { auditsManifest } from './audits';
import { deputyRequestsManifest } from './deputy-requests';
import { inquiriesManifest } from './inquiries';
import { interpellationsManifest } from './interpellations';

/** Група модулів «Контроль» (Oversight): 4 модулів. */
export const oversightGroup: IModuleGroupManifest = {
  key: 'oversight',
  category: 'Oversight',
  name: { en: 'Oversight', uk: 'Контроль' },
  sort: 16,
  modules: [auditsManifest, deputyRequestsManifest, inquiriesManifest, interpellationsManifest],
};
